import React from 'react';
import { useReveal } from '../hooks/useReveal';
import { ArrowRightIcon, CheckIcon } from 'lucide-react';
export function Hero() {
  const revealRef = useReveal();
  return <section className="relative bg-forest overflow-hidden rounded-b-[40px]" style={{
    backgroundImage: "linear-gradient(180deg, rgba(60,70,38,0.82), rgba(42,49,23,0.92)), url('https://images.unsplash.com/photo-1741874299706-2b8e16839aaa?auto=format&fit=crop&w=2400&q=80')",
    backgroundSize: 'cover',
    backgroundPosition: 'center'
  }} data-id="element-101">
      <svg className="absolute right-0 top-0 opacity-[0.1] pointer-events-none hidden sm:block" width="300" height="200" viewBox="0 0 300 200" fill="none" stroke="#FFFFFF" strokeWidth="1.4" aria-hidden="true" data-id="element-102">
        <path d="M260 5c-9 26-30 40-54 40-26 0-47-19-47-44 0-23 17-40 42-40 3 0 7 0 10 1" data-id="element-103" />
        <ellipse cx="205" cy="5" rx="30" ry="40" transform="rotate(106 205 5)" data-id="element-104" />
        <ellipse cx="222" cy="-38" rx="22" ry="32" transform="rotate(82 222 -38)" data-id="element-105" />
        <path d="M165 -8c22 8 44 5 62-9 18-15 23-39 13-59" data-id="element-106" />
        <circle cx="115" cy="32" r="18" data-id="element-107" />
        <circle cx="140" cy="7" r="13" data-id="element-108" />
      </svg>

      <div className="max-w-7xl mx-auto px-5 sm:px-8 pt-12 pb-20 lg:pt-16 lg:pb-28 relative" data-id="element-109">
        <div className="grid lg:grid-cols-2 gap-14 items-center" data-id="element-110">
          <div data-id="element-111">
            <span className="eyebrow text-forest mb-7 reveal" data-id="element-112">
              Regulated · Technology-Enabled · Kenya
            </span>
            <h1 className="font-display text-paper text-4xl sm:text-5xl lg:text-[3.2rem] leading-[1.15] mt-6" data-id="element-113">
              Building Africa's <span className="text-leaf" data-id="element-114">Trusted</span>{' '}
              Commodity Exchange
            </h1>
            <p className="mt-6 text-paper/80 text-lg leading-relaxed max-w-xl" data-id="element-115">
              A regulated, technology-enabled ecosystem powering modern
              agricultural trade — connecting storage, financing, marketplace
              and settlement into one platform Kenya's agricultural economy can
              finally trust.
            </p>
            <div className="mt-9 flex flex-wrap gap-4" data-id="element-116">
              <a href="#contact" className="btn-pill btn-on-dark bg-gold hover:bg-goldlight text-forestdeep pl-6 pr-1.5 py-1.5" data-id="element-117">
                <span className="py-2" data-id="element-118">Talk to AFEXA</span>
                <span className="btn-arrow" data-id="element-119">
                  <ArrowRightIcon width="14" height="14" strokeWidth={2.5} data-id="element-120" />
                </span>
              </a>
            </div>
          </div>

          <div ref={revealRef} className="reveal" data-id="element-121">
            <div className="receipt p-6 sm:p-7 max-w-md mx-auto lg:ml-auto shadow-2xl" data-id="element-122">
              <div className="flex justify-between items-start mb-5" data-id="element-123">
                <div data-id="element-124">
                  <span className="inline-block bg-leaflight text-forest rounded-full px-3.5 py-1.5 text-xs font-semibold" data-id="element-125">
                    Digital Warehouse Receipt
                  </span>
                  <p className="font-display text-ink text-xl mt-3" data-id="element-126">
                    Bankable Collateral
                  </p>
                </div>
                <span className="receipt-serial text-golddark" data-id="element-127">
                  AFEXA‑WR‑04521
                </span>
              </div>
              <div className="space-y-3 text-sm" data-id="element-128">
                <div className="flex justify-between border-b border-line pb-2" data-id="element-129">
                  <span className="text-ink/55" data-id="element-130">Commodity</span>
                  <span className="text-ink font-medium" data-id="element-131">Maize — Grade A</span>
                </div>
                <div className="flex justify-between border-b border-line pb-2" data-id="element-132">
                  <span className="text-ink/55" data-id="element-133">Quantity</span>
                  <span className="text-ink font-medium" data-id="element-134">50 MT</span>
                </div>
                <div className="flex justify-between border-b border-line pb-2" data-id="element-135">
                  <span className="text-ink/55" data-id="element-136">Facility</span>
                  <span className="text-ink font-medium" data-id="element-137">
                    Licensed Warehouse
                  </span>
                </div>
                <div className="flex justify-between" data-id="element-138">
                  <span className="text-ink/55" data-id="element-139">Status</span>
                  <span className="text-leaf font-medium" data-id="element-140">
                    Traceable · Financeable
                  </span>
                </div>
              </div>
              <div className="mt-6 pt-5 border-t border-line flex items-center gap-3" data-id="element-141">
                <div className="verified-badge" data-id="element-142">
                  <CheckIcon width="18" height="18" strokeWidth={3} color="#424D27" data-id="element-143" />
                </div>
                <span className="text-ink/55 text-xs leading-snug" data-id="element-144">
                  Issued under the Warehouse Receipt System Act, 2019
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}